function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m29.889 12.472c-.245-.729-.857-1.252-1.6-1.366l-7.187-1.103-3.221-6.834c-.336-.721-1.029-1.168-1.807-1.168-.778 0-1.471.448-1.807 1.166l-3.222 6.837-7.187 1.103c-.742.114-1.355.638-1.6 1.366-.252.751-.069 1.568.477 2.13l5.23 5.382-1.236 7.612c-.13.802.194 1.584.847 2.043.34.239.734.36 1.13.36.327 0 .654-.083.955-.249l6.396-3.568 6.431 3.568c.664.369 1.463.326 2.084-.111.653-.458.977-1.241.847-2.042l-1.236-7.612 5.23-5.382c.546-.562.729-1.378.477-2.13z",
  fill: "#ffcb2b"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.50035a58.svg";
export { ForwardRef as ReactComponent };